export default {
  gpuSnapshot: {
    LOADING: '正在获取数据，当前数量尚未确认。',
    UNAVAILABLE: '暂时无法获取数据，请稍后刷新；当前不能确认是否为空。',
    STALE: '刷新未成功，以下为上次成功获取的数据；当前状态尚未确认。'
  },
  gpuCapacityWait: {
    QUEUED: '等待调度',
    WAITING_CAPACITY: '等待可用资源',
    WARMING: '正在准备运行资源',
    BACKOFF: '资源准备暂缓重试',
    CONFIRMING: '资源状态待确认'
  },
  gpuReplacement: {
    title: '实例替换进度（只读）',
    scope: '仅显示实例替换，不代表整个资源池或所有等待任务的状态。',
    trigger: '触发任务：{{id}}',
    updated: '状态更新时间：{{time}}',
    retry: '下次重试不早于：{{time}}，不代表任务完成时间',
    phase: {
      LOADING: '正在读取状态',
      NONE: '当前没有活动替换',
      DRAINING: '正在排空原实例',
      REPLACING: '正在替换实例',
      WARMING: '正在准备替换目标',
      BACKOFF: '等待重试',
      CONFIRMING: '正在确认替换结果',
      UNAVAILABLE: '状态暂时无法确认'
    }
  }
};
